export function getFileExtension(fileName: string, withDot: boolean = false) {
  const nameParts = fileName.split('.');
  return (withDot ? '.' : '') + nameParts[nameParts.length - 1].toLowerCase();
}

export function getFileName(fileName: string) {
  const extensionIndex = fileName.lastIndexOf('.');
  return fileName.substring(0, extensionIndex);
}
